import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { PasswordInput } from './ui';
import { BookOpenIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { safeErrorMessage } from '../utils/apiError';
import styles from './Login.module.css';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError('This reset link is missing its token. Please request a new one.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('/api/v1/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: newPassword }),
      });
      if (response.ok) {
        setSuccess(true);
        setTimeout(() => navigate('/'), 2500);
      } else {
        setError(await safeErrorMessage(response, 'Something went wrong. Please try again.'));
      }
    } catch (err) {
      setError('Network error. Is the backend running?');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.iconWrap}>
            <BookOpenIcon className={styles.icon} />
          </div>
          <h1 className={styles.title}>Reset Password</h1>
          <p className={styles.subtitle}>Choose a new password for your account.</p>
        </div>

        {error && <div className={styles.error}>{error}</div>}
        {success && (
          <div className={styles.success}>Password updated successfully. Redirecting to login...</div>
        )}

        {!success && (
          <form onSubmit={handleSubmit}>
            <div className={styles.field}>
              <label className={styles.label}>New Password</label>
              <div className={styles.inputWrap}>
                <LockClosedIcon className={styles.inputIcon} />
                <PasswordInput
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  minLength={6}
                  placeholder="Enter new password"
                  className={styles.input}
                />
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label}>Confirm Password</label>
              <div className={styles.inputWrap}>
                <LockClosedIcon className={styles.inputIcon} />
                <PasswordInput
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  minLength={6}
                  placeholder="Confirm new password"
                  className={styles.input}
                />
              </div>
            </div>

            <button type="submit" className={styles.submitBtn} disabled={loading}>
              {loading ? (
                <>
                  <span className={styles.spinner} />
                  Saving...
                </>
              ) : (
                'Reset Password'
              )}
            </button>
          </form>
        )}

        <p className={styles.linkRow}>
          <Link to="/" className={styles.link}>Back to login</Link>
        </p>
      </div>
    </div>
  );
}

export default ResetPassword;
